<script lang="ts">
    import type { BlogPost } from '../../api/blogs.ts';
    import { noPictureUrl } from '../../api/common.ts';
    import { push } from 'svelte-spa-router';

    export let post: BlogPost;
    export let image: string;
    
    function goToBlogPost() {
        push(`/Blog/${post.id}`);
    }
</script>

<!-- Make the entire card clickable -->
<div
        role="link"
        tabindex="0"
        on:click={goToBlogPost}
        on:keydown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            goToBlogPost();
        }
    }}
        class="block w-full box-border cursor-pointer transition-transform duration-200 ease-in-out hover:scale-105"
>
    <div
            class="flex flex-col md:flex-row border border-gray-300 bg-white overflow-hidden h-auto md:h-[320px] rounded-lg"
            data-testid={`blog-post-${post.id}`}
    >
        <img
                src={image}
                alt={post.headline}
                class="w-full h-[160px] md:w-1/2 md:h-full object-cover"
                data-testid="image"
        />

        <div class="w-full md:w-1/2 p-4 md:p-6 flex flex-col gap-3 justify-between" data-testid="content">
            <div class="flex items-start gap-3">
                <img
                        src={noPictureUrl}
                        alt="Author Avatar"
                        class="w-10 h-10 md:w-12 md:h-12 rounded-full"
                />
                <div class="flex flex-col gap-1 justify-start">
                    <p class="text-sm md:text-base font-medium text-gray-800 leading-none" style="margin-bottom:0;" data-testid="author">{post.author}</p>
                    <p class="text-sm text-gray-500 leading-none" style="margin-top:0;" data-testid="date">
                        {post.getDisplayedPublicationDate()}
                    </p>
                </div>
            </div>

            <div class="flex flex-col gap-2 mt-3 flex-1">
                <h3 class="text-base md:text-lg font-semibold text-black line-clamp-2" data-testid="headline">
                    {post.headline}
                </h3>

                <p class="text-sm md:text-base text-gray-600 leading-relaxed" data-testid="shortened alert">
                    {post.shortenedAlert}
                </p>
            </div>
        </div>
    </div>
</div>
